import { type GatsbyBrowser } from 'gatsby'

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({
  prevLocation,
}) => {
  // @ts-expect-error
  window.prevLocation = prevLocation
}
